import { ValidationProps } from 'ui/common/validation/types';
import { validateIfFilledOut } from 'app/area/codetable/item/screen-renderer/screen-validate/helpers';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ValidationData } from 'app/area/codetable/item/validation/validate';

export const validateLevel = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation } = validationData;
  
  const levelValidation = validateIfFilledOut('level', isDefinedIncludingZero(codeItem.level), translation);

  return {
    ...levelValidation
  };
};
